import styled from "styled-components";

const Controls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .MuiCardHeader-title {
    margin-bottom: 8px;
  }

  .MuiCardHeader-subheader {
    line-height: 1.1;
    font-size: 14px;
  }

  .control-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    width: 350px;
    border-top: 10px solid #92363b;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
  }

  .submit {
    width: 150px;
    margin: 15px auto;
  }
`;

export default Controls;
